"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchivedFileUpload = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const file_upload_entity_1 = require("./file-upload.entity");
let ArchivedFileUpload = class ArchivedFileUpload {
};
exports.ArchivedFileUpload = ArchivedFileUpload;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_file_upload_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "refFileUploadId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "file_key", type: "text", nullable: false }),
    tslib_1.__metadata("design:type", String)
], ArchivedFileUpload.prototype, "fileKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "new_file_key", type: "text", nullable: false }),
    tslib_1.__metadata("design:type", String)
], ArchivedFileUpload.prototype, "newFileKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "company_type",
        type: "varchar",
        length: 255,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], ArchivedFileUpload.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "upload_type", type: "varchar", length: 50, nullable: false }),
    tslib_1.__metadata("design:type", String)
], ArchivedFileUpload.prototype, "uploadType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "created_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], ArchivedFileUpload.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "updated_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], ArchivedFileUpload.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ArchivedFileUpload.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ArchivedFileUpload.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload),
    (0, typeorm_1.JoinColumn)({ name: "ref_file_upload_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof file_upload_entity_1.FileUpload !== "undefined" && file_upload_entity_1.FileUpload) === "function" ? _d : Object)
], ArchivedFileUpload.prototype, "fileUpload", void 0);
exports.ArchivedFileUpload = ArchivedFileUpload = tslib_1.__decorate([
    (0, typeorm_1.Entity)("archived_file_upload")
], ArchivedFileUpload);
